import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { ChatInboxModel } from '@/models'

export type DeleteCustomChatInboxRequest = Pick<ChatInboxModel, 'id'>

export const deleteCustomChatInbox = async (data: DeleteCustomChatInboxRequest) => {
  const response = await authAPI.delete(`/chat-inbox/${data.id}`)
  return response.data
}

export const useDeleteCustomChatInbox = () => {
  return useMutation({
    mutationFn: deleteCustomChatInbox,
  })
}
